/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NOW_IN_TREASURY = (
    <FormattedMessage
        id='clan_panel.item.now_in_treasury'
        defaultMessage='Сейчас в казне:'
    />
)

export const EARN_RESOURCES_ON_GLOBAL_MAP = {
    gold: (
        <FormattedMessage
            id='clan_panel.item.currency.earn_resources.gold'
            defaultMessage='Заработать золото в казну клана можно на Глобальной карте.'
        />
    ),
    crystal: (
        <FormattedMessage
            id='clan_panel.item.currency.earn_resources.crystal'
            defaultMessage='Заработать боны в казну клана можно на Глобальной карте.'
        />
    ),
    credits: (
        <FormattedMessage
            id='clan_panel.item.currency.earn_resources.silver'
            defaultMessage='Заработать кредиты в казну клана можно на Глобальной карте.'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/CurrencyTooltip/constants.jsx